import jwtAuthAxios from "../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {getMatkul} from "./matkulSlice";
/*

export const getKurikulumAll = createAsyncThunk("kurikulum/getAll", async ({ page, pageSize }) => {
	try {
		let token = await localStorage.getItem('auth_token');
		jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
		const response = await jwtAuthAxios.get(`v1/kurikulum/pageable?page=${page}&size=${pageSize}`)
		return response.data
	} catch (response) {
		throw response
	}
});
*/

export const getKurikulumAll = createAsyncThunk("kurikulum/getAll",
	async({ page, pageSize, search }, thunkAPI) => {
		try{
			let token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const searchParams = search === undefined ? "" : search;
			const url = `v1/kurikulum/pageable?page=${page}&size=${pageSize}&search=${searchParams}`
			const response = await jwtAuthAxios.get(url)
			return response.data
		} catch(response){
			throw response
		}
	});

export const getAllNoPage = createAsyncThunk("kurikulum/getAllNoPage", async () => {
	try {
		let token = await localStorage.getItem('auth_token');
		jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
		const response = await jwtAuthAxios.get(`v1/kurikulum`)
		return response.data
	} catch (response) {
		throw response
	}
});

export const getKurikulumDetail = createAsyncThunk("kurikulum/getKurikulumDetail", async (id) => {
	let token = await localStorage.getItem('auth_token');
	jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
	const response = await jwtAuthAxios.get(`v1/kurikulum/${id}`);
	return response.data;
});

export const getByKurikulumSemester = createAsyncThunk("kurikulum/getByKurikulumSemester",
	async ({ kurikulumId, semester }, thunkAPI) => {
		try {
			let token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			//const url = `v1/kurikulum/mk/filter?kurikulumId=${kurikulumId}&semesterId=${semester}`
			const url = `v1/kurikulum_detail/filter?kurikulumId=${kurikulumId}&semesterId=${semester}`

			const response = await jwtAuthAxios.get(url)
			return response.data
		} catch (response) {
			throw response
		}
	});

export const getByKurikulumAll = createAsyncThunk("kurikulum/getByKurikulumAll",
	async (id_kurikulum, thunkAPI) => {
		try {
			let token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const url = `v1/kurikulum_detail/mk_filter?kurikulumId=${id_kurikulum}`
			const response = await jwtAuthAxios.get(url)
			return response.data
		} catch (response) {
			throw response
		}
	});

export const getKurikulumMataKuliah = createAsyncThunk("kurikulum/getKurikulumMataKuliah", async (id) => {
	let token = await localStorage.getItem('auth_token');
	jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
	const response = await jwtAuthAxios.get(`v1/kurikulum/mk/${id}`);
	return response.data;
});

export const saveKurikulumData = createAsyncThunk("kurikulum/saveKurikulumData", async (payload) => {
	let token = await localStorage.getItem('auth_token');
	jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
	const response = await jwtAuthAxios.post('v1/kurikulum', payload);
	return response.data;
});

export const updateKurikulumData = createAsyncThunk("kurikulum/updateKurikulumData", async (payload) => {
	let token = await localStorage.getItem('auth_token');
	jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
	const response = await jwtAuthAxios.put('v1/kurikulum', payload);
	return response.data;
});

export const saveMappingData = createAsyncThunk("kurikulum/saveMappingData", async (payload) => {
	let token = await localStorage.getItem('auth_token');
	jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
	const response = await jwtAuthAxios.post('v1/kurikulum_detail', payload);
	return response.data;
});

export const deleteKurikulumData = createAsyncThunk("kurikulum/deleteKurikulumData", async (id) => {
	let token = await localStorage.getItem('auth_token');
	jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
	await jwtAuthAxios.delete(`v1/kurikulum/${id}`);
	return id;
});

export const deleteByKurikulumMataKuliah = createAsyncThunk("kurikulum/deleteByKurikulumMataKuliah", async (id) => {
	let token = await localStorage.getItem('auth_token');
	jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
	await jwtAuthAxios.delete(`v1/kurikulum_detail/${id}`);
	return id;
});

const kurikulum = {
	nama_kurikulum: '',
	programStudiId: '',
	periodeId: '',
	jumlah_sks_lulus: 40,
	jumlah_sks_wajib: 40,
	jumlah_sks_pilihan: 0,
	jml_sem_normal: 0
};

const pagination = {
	page: 1,
	pageSize: 10,
	pageSizeOptions: ['10', '20', '30', '50'],
	total: 0,
}

const initialState = {
	dataAllKurikulum: [],
	dataKurikulumDetail: { ...kurikulum },
	dataKurikulumDetailAll: [],
	dataKurikulumMataKuliah: [],
	dataKurikulumSemester: [],
	dataAllNoPage: [],
	dataSaveKurikulum: [],
	steps: {
		current: 0
	},
	status: {
		loading: false
	},
	pagination: {
		dataAllKurikulum: { ...pagination }
	}
}

const kurikulumSlice = createSlice({
	name: "kurikulum",
	initialState: initialState,
	reducers: {
		onRefreshForm: (state) => {
			state.dataKurikulumDetail = initialState.dataKurikulumDetail
			state.status = initialState.status;
		},
		onRefreshStatus: (state) => {
			state.status = initialState.status;
		},
		onRefreshSteps: (state) => {
			state.steps.current = 0;
		},
		onChangeData: (state, action) => ({
			...state,
			...action.payload
		}),
		onChangePagination: (state, action) => {
			const { paginationName, pageChange, pageSizeChange, totalChange } = action.payload;
			state.pagination[paginationName] = {
				...state.pagination[paginationName],
				page: state.pagination[paginationName].pageSize !== pageSizeChange ? 1 : pageChange,
				pageSize: pageSizeChange,
				total: totalChange,
			}
		},
		nextStep: (state) => {
			state.steps.current++;
		},
		prevStep: (state) => {
			state.steps.current--;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getKurikulumAll.pending, (state) => {
				state.status.loading = true;
			})
			.addCase(getKurikulumAll.fulfilled, (state, action) => {
				state.dataAllKurikulum = action.payload;
				state.status.loading = false;
			})
			/*.addCase(getKurikulumAll.fulfilled, (state, action) => {
				const { result, page } = action.payload?.data;
				const { number, size, totalElements } = page;
				state.dataAllKurikulum = result;
				state.pagination.dataAllKurikulum = {
					...state.pagination.dataAllKurikulum,
					page: state.pagination.dataAllKurikulum.pageSize !== size ? 1 : number + 1,
					pageSize: size,
					total: totalElements,
				}
				state.status.loading = false;
			})*/
			.addCase(getKurikulumAll.rejected, (state, action) => {
				state.status.loading = false;
				console.error("Error during:", action.error);
			})
		builder
			.addCase(getKurikulumDetail.pending, (state) => {
				state.status.loading = true;
			})
			.addCase(getKurikulumDetail.fulfilled, (state, action) => {
				const { 
					id_prodi, 
					id_jenj_didik, 
					nama_jenjang_pendidikan, 
					nama_program_studi: prodi,
					semester_mulai_berlaku,
					id_semester,
					...rest 
				} = action.payload;

				const [jenjangPendidikan, ...restProdi] = prodi.split(' ');

				state.dataKurikulumDetail.programStudiId = JSON.stringify({ 
					id_program_studi: id_prodi, 
					id_jenjang_pendidikan: id_jenj_didik,
					nama_jenjang_pendidikan: jenjangPendidikan, 
					nama_program_studi: restProdi.join(' ')
				});

				state.dataKurikulumDetail.periodeId = JSON.stringify({
					nama: semester_mulai_berlaku,
					kode: id_semester
				})
				
				state.dataKurikulumDetail = {
					...state.dataKurikulumDetail,
					...rest
				};
				state.status.loading = false;
			})
			.addCase(getKurikulumDetail.rejected, (state, action) => {
				state.status.loading = false;
				console.error("Error during:", action.error);
			})
		builder
			.addCase(getKurikulumMataKuliah.pending, (state) => {
				state.status.loading = true;
			})
			.addCase(getKurikulumMataKuliah.fulfilled, (state, action) => {
				state.dataKurikulumMataKuliah = action.payload;
				state.status.loading = false;
			})
			.addCase(getKurikulumMataKuliah.rejected, (state, action) => {
				state.status.loading = false;
				console.error("Error during:", action.error);
			})
		builder
			.addCase(getAllNoPage.pending, (state) => {
				state.status.loading = true;
			})
			.addCase(getAllNoPage.fulfilled, (state, action) => {
				state.dataAllNoPage = action.payload;
				state.status.loading = false;
			})
			.addCase(getAllNoPage.rejected, (state, action) => {
				state.status.loading = false;
				console.error("Error during:", action.error);
			})
		builder
			.addCase(getByKurikulumSemester.pending, (state) => {
				state.status.loading = true;
			})
			.addCase(getByKurikulumSemester.fulfilled, (state, action) => {
				state.dataKurikulumSemester = action.payload;
				state.status.loading = false;
			})
			.addCase(getByKurikulumSemester.rejected, (state, action) => {
				state.status.loading = false;
				console.error("Error during:", action.error);
			})
		builder
			.addCase(getByKurikulumAll.pending, (state) => {
				state.status.loading = true;
			})
			.addCase(getByKurikulumAll.fulfilled, (state, action) => {
				state.dataKurikulumDetailAll = action.payload;
				state.status.loading = false;
			})
			.addCase(getByKurikulumAll.rejected, (state, action) => {
				state.status.loading = false;
				console.error("Error during:", action.error);
			})

		builder
			.addCase(saveKurikulumData.pending, (state) => {
				state.status.loading = true;
			})
			.addCase(saveKurikulumData.fulfilled, (state, action) => {
				state.dataSaveKurikulum = action.payload;
				state.status.loading = false;
			})
			.addCase(saveKurikulumData.rejected, (state, action) => {
				state.status.loading = false;
				console.error("Error during:", action.error);
			})

		builder
			.addCase(updateKurikulumData.pending, (state) => {
				state.status.loading = true;
			})
			.addCase(updateKurikulumData.fulfilled, (state, action) => {
				state.dataSaveKurikulum = action.payload;
				state.status.loading = false;
			})
			.addCase(updateKurikulumData.rejected, (state, action) => {
				state.status.loading = false;
				console.error("Error during:", action.error);
			})

		builder
			.addCase(saveMappingData.pending, (state) => {
				state.status.loading = true;
			})
			.addCase(saveMappingData.fulfilled, (state, action) => {
				state.status.loading = false;
			})
			.addCase(saveMappingData.rejected, (state, action) => {
				state.status.loading = false;
				console.error("Error during:", action.error);
			})
		builder
			.addCase(deleteKurikulumData.pending, (state) => {
				state.status.loading = true;
			})
			.addCase(deleteKurikulumData.fulfilled, (state, action) => {
				state.status.loading = false;
			})
			.addCase(deleteKurikulumData.rejected, (state, action) => {
				state.status.loading = false;
				console.error("Error during:", action.error);
			})
		builder
			.addCase(deleteByKurikulumMataKuliah.pending, (state) => {
				state.status.loading = true;
			})
			.addCase(deleteByKurikulumMataKuliah.fulfilled, (state, action) => {
				state.status.loading = false;
			})
			.addCase(deleteByKurikulumMataKuliah.rejected, (state, action) => {
				state.status.loading = false;
				console.error("Error during:", action.error);
			})
	}
})

export const {
	onRefreshForm,
	onRefreshStatus,
	onChangeData,
	nextStep,
	onChangePagination,
	prevStep,
	onRefreshSteps
} = kurikulumSlice.actions;

export const selectKurikulum = (state) => state.kurikulum;
export default kurikulumSlice.reducer;